import { Modal } from '@mantine/core';


import { VisiLoader, HelpTip } from "../../GeneralComponent/GeneralComponent";
import { UniversalSmartCodeContent, useUniversalSmartCode } from '../../GeneralComponent/UniversalSmartCodeContent';
import AdvancedTrackingConfig from '../../Funnel/AdvancedTrackingConfig';

interface UniversalSmartCodeModalProps {
  opened: boolean;
  onClose: () => void;
  websiteId: string | number;
  websiteUrl: string;
  subdomainVisiSmartCode: boolean;
  visiSmartCodeSubdomainId: string | number;
  showAdvancedTracking?: boolean;
  pageId?: string;
  showShopifyConfirmationCode?: boolean;
}

export function UniversalSmartCodeModal({ opened, onClose, websiteId, websiteUrl, subdomainVisiSmartCode, visiSmartCodeSubdomainId, showAdvancedTracking = true, pageId = '', showShopifyConfirmationCode = true }: UniversalSmartCodeModalProps) {
  const { data, loading, reload } = useUniversalSmartCode({
    websiteId,
    isSubdomain: subdomainVisiSmartCode,
    subdomainId: visiSmartCodeSubdomainId,
    pageId,
    enabled: opened,
  });



  return (
    <>
      <Modal.Root size="70%" opened={opened} onClose={onClose} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={loading} />
          <Modal.Header>
            <Modal.Title>UNIVERSAL SMART CODE <HelpTip helpId={data.frontendFramework === '3' ? 369 : data.frontendFramework === '2' ? 372 : data.frontendFramework === '1' ? 374 : data.frontendFramework === '0' ? 377 : 188} /></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            {/* ADVANCED TRACKING DOMAIN SECTION - ABOVE TRACKING CODE */}
            {/* Note: AdvancedTrackingConfig returns null when user has no permission */}
            {showAdvancedTracking && (
              <AdvancedTrackingConfig
                websiteId={websiteId as string}
                websiteUrl={websiteUrl}
                onConfigChange={reload}
              />
            )}
            {/* END ADVANCED TRACKING SECTION */}

            <UniversalSmartCodeContent
              data={data}
              showShopifyConfirmationCode={showShopifyConfirmationCode}
            />
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
